import { actionTypes } from './actions';

const initialState = { childInn: '' };

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_CHILD_INN:
      return { ...state, childInn: action.payload };
    default:
      return state;
  }
}
